
<div class="container">


              <h2 class="content-heading">
                  <button class="btn btn-sm btn-outline-secondary float-right" (click)="add()">
                    <i class="fa fa-plus mr-5"></i>Service Date Type
                  </button>
                    Service Date Type
              </h2>


            <div class="block">

              <!--
              <div class="block-header block-header-default">
                  <h3 class="block-title"></h3>
              </div>
            -->

              <div class="block-content">
                  <div class="table-responsive ">
                      <table class="table table-striped table-vcenter table-sm">
                          <thead>
                              <tr>
                                <th>Name</th>
                                <th>Description</th>
                                <th class="text-center" style="width: 100px;">Actions</th>
                              </tr>
                          </thead>
                          <tbody>


                            <tr *ngFor="let obj of entities">
                              <td class="font-w600">{{obj.Localized[0].Name}}</td>
                              <td class="font-w600">{{obj.Localized[0].Description}} </td>
                              <td class="text-center">
                                  <div class="btn-group">
                                      <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Edit" (click)="edit(obj)">
                                          <i class="fa fa-pencil"></i>
                                      </button>
                                      <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Delete" (click)="delete(obj)">
                                          <i class="fa fa-times"></i>
                                      </button>
                                  </div>
                              </td>
                            </tr>

                          </tbody>
                      </table>

                      <app-progress-bar *ngIf="isLoading==true"></app-progress-bar>

                    </div>


              </div>

            </div>

            </div>

